export default function dueDateCalculator(dueDate: Date, ...increments: number[]) {
	const incrementsSum = increments.reduce((acc, curr) => acc + curr, 0);
	dueDate.setDate(dueDate.getDate() + incrementsSum);
	return dueDate;
}
